import type { Locale, QRTranslation, Advertisement } from './types';

export const qrTranslations = {
  ko: {
    flashText: '플래시 켜기',
    flashOnAriaLabel: '플래시 켜기',
    flashOffAriaLabel: '플래시 끄기',
    scanText: 'QR 코드를 스캔하세요',
    scanButton: '스캔하기',
    instruction: '스캔할 수 없나요? 웨이터에게 도움을 요청하거나 수동으로 테이블 번호를 입력하세요',
    cameraStarting: '카메라 시작 중...',
    scanning: '스캔 중...',
    cameraError: '카메라 접근 불가',
    cameraPermissionDenied: '카메라 권한이 차단되어 있습니다. 브라우저 설정에서 카메라를 허용해 주세요',
    cameraPermissionHint: "iPhone Safari: 주소창의 'aA' 또는 설정 > 앱 > Safari > 카메라에서 허용",
    cameraUnsupported: '이 브라우저에서는 카메라를 사용할 수 없습니다. 기본 브라우저(Safari/Chrome)에서 열어 주세요',
    cameraInUse: '다른 앱이 카메라를 사용 중입니다. 해당 앱을 종료한 후 다시 시도해 주세요',
    cameraRetry: '카메라 다시 시도',
    clickToScan: '화면을 탭하여 스캔'
  },
  es: {
    flashText: 'Prender flash',
    flashOnAriaLabel: 'Prender flash',
    flashOffAriaLabel: 'Apagar flash',
    scanText: 'Escanee el código QR',
    scanButton: 'Escanear',
    instruction: '¿No puede escanear? Solicite ayuda al mesero o utilice el número de mesa manual',
    cameraStarting: 'Iniciando cámara...',
    scanning: 'Escaneando...',
    cameraError: 'No se puede acceder a la cámara',
    cameraPermissionDenied: 'El permiso de cámara está bloqueado. Permita la cámara en la configuración del navegador',
    cameraPermissionHint: "iPhone Safari: toque 'aA' en la barra de direcciones o Ajustes > Apps > Safari > Cámara",
    cameraUnsupported: 'Este navegador no admite la cámara. Abra la página en su navegador principal (Safari/Chrome)',
    cameraInUse: 'Otra aplicación está usando la cámara. Ciérrela e intente de nuevo',
    cameraRetry: 'Reintentar cámara',
    clickToScan: 'Toque la pantalla para escanear'
  },
  en: {
    flashText: 'Turn on flash',
    flashOnAriaLabel: 'Turn on flash',
    flashOffAriaLabel: 'Turn off flash',
    scanText: 'Scan the QR code',
    scanButton: 'Scan',
    instruction: 'Can\'t scan? Ask your waiter for help or use manual table number',
    cameraStarting: 'Starting camera...',
    scanning: 'Scanning...',
    cameraError: 'Cannot access camera',
    cameraPermissionDenied: 'Camera permission is blocked. Please allow camera access in your browser settings',
    cameraPermissionHint: "iPhone Safari: tap 'aA' in the address bar or Settings > Apps > Safari > Camera",
    cameraUnsupported: 'This browser does not support the camera. Please open the page in your main browser (Safari/Chrome)',
    cameraInUse: 'Another app is using the camera. Close it and try again',
    cameraRetry: 'Retry camera',
    clickToScan: 'Tap screen to scan'
  },
  pt: {
    flashText: 'Ligar flash',
    flashOnAriaLabel: 'Ligar flash',
    flashOffAriaLabel: 'Desligar flash',
    scanText: 'Escaneie o código QR',
    scanButton: 'Escanear',
    instruction: 'Não consegue escanear? Peça ajuda ao garçom ou informe o número da mesa manualmente',
    cameraStarting: 'Iniciando câmera...',
    scanning: 'Escaneando...',
    cameraError: 'Não foi possível acessar a câmera',
    cameraPermissionDenied: 'A permissão da câmera está bloqueada. Permita a câmera nas configurações do navegador',
    cameraPermissionHint: "iPhone Safari: toque em 'aA' na barra de endereço ou Ajustes > Apps > Safari > Câmera",
    cameraUnsupported: 'Este navegador não suporta a câmera. Abra a página no seu navegador principal (Safari/Chrome)',
    cameraInUse: 'Outro aplicativo está usando a câmera. Feche-o e tente novamente',
    cameraRetry: 'Tentar câmera novamente',
    clickToScan: 'Toque na tela para escanear'
  },
  fr: {
    flashText: 'Activer le flash',
    flashOnAriaLabel: 'Activer le flash',
    flashOffAriaLabel: 'Désactiver le flash',
    scanText: 'Scannez le code QR',
    scanButton: 'Scanner',
    instruction: 'Vous n\'arrivez pas à scanner ? Demandez de l\'aide au serveur ou saisissez le numéro de table manuellement',
    cameraStarting: 'Démarrage de la caméra...',
    scanning: 'Scan en cours...',
    cameraError: 'Impossible d\'accéder à la caméra',
    cameraPermissionDenied: 'L\'accès à la caméra est bloqué. Autorisez la caméra dans les réglages du navigateur',
    cameraPermissionHint: 'iPhone Safari : touchez « aA » dans la barre d\'adresse ou Réglages > Apps > Safari > Caméra',
    cameraUnsupported: 'Ce navigateur ne prend pas en charge la caméra. Ouvrez la page dans votre navigateur principal (Safari/Chrome)',
    cameraInUse: 'Une autre application utilise la caméra. Fermez-la puis réessayez',
    cameraRetry: 'Réessayer la caméra',
    clickToScan: 'Touchez l\'écran pour scanner'
  },
  zh: {
    flashText: '打开闪光灯',
    flashOnAriaLabel: '打开闪光灯',
    flashOffAriaLabel: '关闭闪光灯',
    scanText: '扫描二维码',
    scanButton: '扫描',
    instruction: '无法扫描？请向服务员求助，或手动输入桌号',
    cameraStarting: '正在启动摄像头...',
    scanning: '正在扫描...',
    cameraError: '无法访问摄像头',
    cameraPermissionDenied: '摄像头权限已被禁止。请在浏览器设置中允许使用摄像头',
    cameraPermissionHint: 'iPhone Safari：点击地址栏 “aA” 或 设置 > App > Safari > 摄像头',
    cameraUnsupported: '此浏览器不支持摄像头。请在默认浏览器（Safari/Chrome）中打开',
    cameraInUse: '其他应用正在使用摄像头。请关闭后重试',
    cameraRetry: '重试摄像头',
    clickToScan: '点击屏幕开始扫描'
  },
  ja: {
    flashText: 'フラッシュをオン',
    flashOnAriaLabel: 'フラッシュをオン',
    flashOffAriaLabel: 'フラッシュをオフ',
    scanText: 'QRコードをスキャンしてください',
    scanButton: 'スキャン',
    instruction: '読み取れない場合はスタッフにお声がけいただくか、テーブル番号を手入力してください',
    cameraStarting: 'カメラを起動中...',
    scanning: 'スキャン中...',
    cameraError: 'カメラにアクセスできません',
    cameraPermissionDenied: 'カメラの権限がブロックされています。ブラウザの設定でカメラを許可してください',
    cameraPermissionHint: 'iPhone Safari: アドレスバーの「aA」または 設定 > アプリ > Safari > カメラ から許可',
    cameraUnsupported: 'このブラウザではカメラを使用できません。標準ブラウザ（Safari/Chrome）で開いてください',
    cameraInUse: '他のアプリがカメラを使用中です。終了してから再試行してください',
    cameraRetry: 'カメラを再試行',
    clickToScan: '画面をタップしてスキャン'
  },
  hi: {
    flashText: 'फ्लैश चालू करें',
    flashOnAriaLabel: 'फ्लैश चालू करें',
    flashOffAriaLabel: 'फ्लैश बंद करें',
    scanText: 'QR कोड स्कैन करें',
    scanButton: 'स्कैन करें',
    instruction: 'स्कैन नहीं हो रहा? वेटर से मदद मांगें या टेबल नंबर हाथ से दर्ज करें',
    cameraStarting: 'कैमरा शुरू हो रहा है...',
    scanning: 'स्कैन हो रहा है...',
    cameraError: 'कैमरे तक पहुंच नहीं हो सकी',
    cameraPermissionDenied: 'कैमरा अनुमति अवरुद्ध है। कृपया ब्राउज़र सेटिंग में कैमरे की अनुमति दें',
    cameraPermissionHint: "iPhone Safari: पता बार में 'aA' टैप करें या सेटिंग्स > ऐप्स > Safari > कैमरा",
    cameraUnsupported: 'यह ब्राउज़र कैमरा सपोर्ट नहीं करता। कृपया पेज को मुख्य ब्राउज़र (Safari/Chrome) में खोलें',
    cameraInUse: 'कोई अन्य ऐप कैमरे का उपयोग कर रहा है। उसे बंद करके फिर से प्रयास करें',
    cameraRetry: 'कैमरा फिर से आज़माएं',
    clickToScan: 'स्कैन करने के लिए स्क्रीन टैप करें'
  },
  de: {
    flashText: 'Blitz einschalten',
    flashOnAriaLabel: 'Blitz einschalten',
    flashOffAriaLabel: 'Blitz ausschalten',
    scanText: 'QR-Code scannen',
    scanButton: 'Scannen',
    instruction: 'Kannst du nicht scannen? Bitte den Service um Hilfe oder gib die Tischnummer manuell ein',
    cameraStarting: 'Kamera wird gestartet...',
    scanning: 'Scannen...',
    cameraError: 'Kein Zugriff auf die Kamera',
    cameraPermissionDenied: 'Der Kamerazugriff ist blockiert. Bitte erlaube die Kamera in den Browsereinstellungen',
    cameraPermissionHint: 'iPhone Safari: Tippe auf „aA“ in der Adressleiste oder Einstellungen > Apps > Safari > Kamera',
    cameraUnsupported: 'Dieser Browser unterstützt die Kamera nicht. Bitte öffne die Seite im Standardbrowser (Safari/Chrome)',
    cameraInUse: 'Eine andere App verwendet die Kamera. Schließe sie und versuche es erneut',
    cameraRetry: 'Kamera erneut versuchen',
    clickToScan: 'Zum Scannen auf den Bildschirm tippen'
  },
  it: {
    flashText: 'Attiva flash',
    flashOnAriaLabel: 'Attiva flash',
    flashOffAriaLabel: 'Disattiva flash',
    scanText: 'Scansiona il codice QR',
    scanButton: 'Scansiona',
    instruction: 'Non riesci a scansionare? Chiedi aiuto al cameriere o inserisci manualmente il numero del tavolo',
    cameraStarting: 'Avvio fotocamera...',
    scanning: 'Scansione...',
    cameraError: 'Impossibile accedere alla fotocamera',
    cameraPermissionDenied: 'L\'accesso alla fotocamera è bloccato. Consenti la fotocamera nelle impostazioni del browser',
    cameraPermissionHint: "iPhone Safari: tocca 'aA' nella barra degli indirizzi o Impostazioni > App > Safari > Fotocamera",
    cameraUnsupported: 'Questo browser non supporta la fotocamera. Apri la pagina nel browser principale (Safari/Chrome)',
    cameraInUse: 'Un\'altra app sta usando la fotocamera. Chiudila e riprova',
    cameraRetry: 'Riprova fotocamera',
    clickToScan: 'Tocca lo schermo per scansionare'
  },
  ru: {
    flashText: 'Включить вспышку',
    flashOnAriaLabel: 'Включить вспышку',
    flashOffAriaLabel: 'Выключить вспышку',
    scanText: 'Отсканируйте QR-код',
    scanButton: 'Сканировать',
    instruction: 'Не получается отсканировать? Попросите официанта помочь или введите номер стола вручную',
    cameraStarting: 'Запуск камеры...',
    scanning: 'Сканирование...',
    cameraError: 'Нет доступа к камере',
    cameraPermissionDenied: 'Доступ к камере заблокирован. Разрешите камеру в настройках браузера',
    cameraPermissionHint: 'iPhone Safari: нажмите «aA» в адресной строке или Настройки > Приложения > Safari > Камера',
    cameraUnsupported: 'Этот браузер не поддерживает камеру. Откройте страницу в основном браузере (Safari/Chrome)',
    cameraInUse: 'Камеру использует другое приложение. Закройте его и попробуйте снова',
    cameraRetry: 'Повторить попытку',
    clickToScan: 'Нажмите на экран для сканирования'
  },
  ar: {
    flashText: 'تشغيل الفلاش',
    flashOnAriaLabel: 'تشغيل الفلاش',
    flashOffAriaLabel: 'إيقاف الفلاش',
    scanText: 'امسح رمز QR',
    scanButton: 'مسح',
    instruction: 'لا يمكنك المسح؟ اطلب المساعدة من النادل أو أدخل رقم الطاولة يدويًا',
    cameraStarting: 'جارٍ تشغيل الكاميرا...',
    scanning: 'جارٍ المسح...',
    cameraError: 'لا يمكن الوصول إلى الكاميرا',
    cameraPermissionDenied: 'تم حظر إذن الكاميرا. يرجى السماح بالكاميرا من إعدادات المتصفح',
    cameraPermissionHint: "iPhone Safari: اضغط على 'aA' في شريط العنوان أو الإعدادات > التطبيقات > Safari > الكاميرا",
    cameraUnsupported: 'هذا المتصفح لا يدعم الكاميرا. يرجى فتح الصفحة في المتصفح الأساسي (Safari/Chrome)',
    cameraInUse: 'تطبيق آخر يستخدم الكاميرا. أغلقه ثم حاول مرة أخرى',
    cameraRetry: 'إعادة محاولة الكاميرا',
    clickToScan: 'اضغط على الشاشة للمسح'
  },
  vi: {
    flashText: 'Bật đèn flash',
    flashOnAriaLabel: 'Bật đèn flash',
    flashOffAriaLabel: 'Tắt đèn flash',
    scanText: 'Quét mã QR',
    scanButton: 'Quét',
    instruction: 'Không quét được? Hãy nhờ nhân viên hỗ trợ hoặc nhập số bàn thủ công',
    cameraStarting: 'Đang khởi động camera...',
    scanning: 'Đang quét...',
    cameraError: 'Không thể truy cập camera',
    cameraPermissionDenied: 'Quyền camera đã bị chặn. Vui lòng cho phép camera trong cài đặt trình duyệt',
    cameraPermissionHint: "iPhone Safari: chạm 'aA' trên thanh địa chỉ hoặc Cài đặt > Ứng dụng > Safari > Camera",
    cameraUnsupported: 'Trình duyệt này không hỗ trợ camera. Vui lòng mở trang bằng trình duyệt chính (Safari/Chrome)',
    cameraInUse: 'Ứng dụng khác đang sử dụng camera. Hãy đóng ứng dụng đó và thử lại',
    cameraRetry: 'Thử lại camera',
    clickToScan: 'Chạm màn hình để quét'
  },
  th: {
    flashText: 'เปิดแฟลช',
    flashOnAriaLabel: 'เปิดแฟลช',
    flashOffAriaLabel: 'ปิดแฟลช',
    scanText: 'สแกน QR โค้ด',
    scanButton: 'สแกน',
    instruction: 'สแกนไม่ได้? ขอความช่วยเหลือจากพนักงานหรือป้อนหมายเลขโต๊ะเอง',
    cameraStarting: 'กำลังเปิดกล้อง...',
    scanning: 'กำลังสแกน...',
    cameraError: 'ไม่สามารถเข้าถึงกล้องได้',
    cameraPermissionDenied: 'สิทธิ์กล้องถูกบล็อก กรุณาอนุญาตกล้องในการตั้งค่าเบราว์เซอร์',
    cameraPermissionHint: "iPhone Safari: แตะ 'aA' ในแถบที่อยู่ หรือ การตั้งค่า > แอป > Safari > กล้อง",
    cameraUnsupported: 'เบราว์เซอร์นี้ไม่รองรับกล้อง กรุณาเปิดหน้านี้ในเบราว์เซอร์หลัก (Safari/Chrome)',
    cameraInUse: 'แอปอื่นกำลังใช้กล้องอยู่ กรุณาปิดแอปนั้นแล้วลองใหม่',
    cameraRetry: 'ลองใช้กล้องอีกครั้ง',
    clickToScan: 'แตะหน้าจอเพื่อสแกน'
  },
  nl: {
    flashText: 'Flits inschakelen',
    flashOnAriaLabel: 'Flits inschakelen',
    flashOffAriaLabel: 'Flits uitschakelen',
    scanText: 'Scan de QR-code',
    scanButton: 'Scannen',
    instruction: 'Lukt scannen niet? Vraag de ober om hulp of voer het tafelnummer handmatig in',
    cameraStarting: 'Camera wordt gestart...',
    scanning: 'Scannen...',
    cameraError: 'Geen toegang tot camera',
    cameraPermissionDenied: 'Cameratoegang is geblokkeerd. Sta de camera toe in de browserinstellingen',
    cameraPermissionHint: "iPhone Safari: tik op 'aA' in de adresbalk of Instellingen > Apps > Safari > Camera",
    cameraUnsupported: 'Deze browser ondersteunt de camera niet. Open de pagina in je hoofdbrowser (Safari/Chrome)',
    cameraInUse: 'Een andere app gebruikt de camera. Sluit die app en probeer het opnieuw',
    cameraRetry: 'Camera opnieuw proberen',
    clickToScan: 'Tik op het scherm om te scannen'
  }
} satisfies Record<Locale, QRTranslation>;

export function getQRTranslation(locale: Locale): QRTranslation {
  return qrTranslations[locale];
}

function getAdvertisementCopy(locale: Locale, copy: Record<Locale, string>): string {
  return copy[locale];
}

export function getAdvertisements(locale: Locale): Advertisement[] {
  return [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1758709187839-7b181ce8968a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwZm9vZCUyMHByb21vdGlvbiUyMGJhbm5lcnxlbnwxfHx8fDE3NTkyOTk5NTN8MA&ixlib=rb-4.1.0&q=80&w=1080',
      title: getAdvertisementCopy(locale, {
        ko: '신규 회원 특별 할인',
        es: 'Descuento especial para nuevos miembros',
        en: 'Special discount for new members',
        pt: 'Desconto especial para novos membros',
        fr: 'Remise spéciale pour les nouveaux membres',
        zh: '新会员专属优惠',
        ja: '新規会員限定割引',
        hi: 'नए सदस्यों के लिए विशेष छूट',
        de: 'Sonderrabatt für neue Mitglieder',
        it: 'Sconto speciale per nuovi membri',
        ru: 'Специальная скидка для новых участников',
        ar: 'خصم خاص للأعضاء الجدد',
        vi: 'Ưu đãi đặc biệt cho thành viên mới',
        th: 'ส่วนลดพิเศษสำหรับสมาชิกใหม่',
        nl: 'Speciale korting voor nieuwe leden',
      }),
      description: getAdvertisementCopy(locale, {
        ko: '첫 주문 30% 할인',
        es: '30% de descuento en su primer pedido',
        en: '30% off your first order',
        pt: '30% de desconto no primeiro pedido',
        fr: '30 % de réduction sur votre première commande',
        zh: '首单立减 30%',
        ja: '初回注文が30%オフ',
        hi: 'पहले ऑर्डर पर 30% छूट',
        de: '30 % Rabatt auf deine erste Bestellung',
        it: '30% di sconto sul primo ordine',
        ru: 'Скидка 30% на первый заказ',
        ar: 'خصم 30% على طلبك الأول',
        vi: 'Giảm 30% cho đơn hàng đầu tiên',
        th: 'ลด 30% สำหรับคำสั่งซื้อแรก',
        nl: '30% korting op je eerste bestelling',
      })
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1758795679604-5f9ffcadc030?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzcGVjaWFsJTIwZGlzY291bnQlMjBvZmZlcnxlbnwxfHx8fDE3NTkyOTk5NTN8MA&ixlib=rb-4.1.0&q=80&w=1080',
      title: getAdvertisementCopy(locale, {
        ko: '주말 특별 이벤트',
        es: 'Evento especial de fin de semana',
        en: 'Weekend special event',
        pt: 'Evento especial de fim de semana',
        fr: 'Événement spécial du week-end',
        zh: '周末特别活动',
        ja: '週末限定イベント',
        hi: 'सप्ताहांत विशेष इवेंट',
        de: 'Wochenendaktion',
        it: 'Evento speciale del weekend',
        ru: 'Специальная акция выходного дня',
        ar: 'فعالية خاصة لعطلة نهاية الأسبوع',
        vi: 'Sự kiện đặc biệt cuối tuần',
        th: 'กิจกรรมพิเศษสุดสัปดาห์',
        nl: 'Speciaal weekendevenement',
      }),
      description: getAdvertisementCopy(locale, {
        ko: '모든 메뉴 20% 할인',
        es: '20% de descuento en todos los menús',
        en: '20% off all menu items',
        pt: '20% de desconto em todos os menus',
        fr: '20 % de réduction sur tout le menu',
        zh: '所有菜品 20% 优惠',
        ja: '全メニュー20%オフ',
        hi: 'सभी मेनू आइटम पर 20% छूट',
        de: '20 % Rabatt auf alle Gerichte',
        it: '20% di sconto su tutti i menu',
        ru: 'Скидка 20% на все блюда',
        ar: 'خصم 20% على جميع الأصناف',
        vi: 'Giảm 20% cho tất cả món',
        th: 'ลด 20% ทุกเมนู',
        nl: '20% korting op alle menu-items',
      })
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1752485407692-e2721d242afc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHxmb29kJTIwZGVsaXZlcnklMjBwcm9tb3Rpb258ZW58MXx8fHwxNzU5MjEzMzE3fDA&ixlib=rb-4.1.0&q=80&w=1080',
      title: getAdvertisementCopy(locale, {
        ko: '무료 배달 프로모션',
        es: 'Promoción de entrega gratuita',
        en: 'Free delivery promotion',
        pt: 'Promoção de entrega grátis',
        fr: 'Livraison gratuite',
        zh: '免费配送活动',
        ja: '無料配達プロモーション',
        hi: 'मुफ्त डिलीवरी प्रोमोशन',
        de: 'Aktion für kostenlose Lieferung',
        it: 'Promozione consegna gratuita',
        ru: 'Акция с бесплатной доставкой',
        ar: 'عرض توصيل مجاني',
        vi: 'Ưu đãi giao hàng miễn phí',
        th: 'โปรโมชันส่งฟรี',
        nl: 'Gratis bezorgactie',
      }),
      description: getAdvertisementCopy(locale, {
        ko: '₩30,000 이상 주문 시',
        es: 'En pedidos superiores a $30,000',
        en: 'On orders over ₩30,000',
        pt: 'Em pedidos acima de $30,000',
        fr: 'Pour les commandes de plus de $30,000',
        zh: '订单满 $30,000',
        ja: '$30,000以上の注文で',
        hi: '$30,000 से अधिक के ऑर्डर पर',
        de: 'Bei Bestellungen über $30,000',
        it: 'Per ordini superiori a $30,000',
        ru: 'При заказах от ₩30,000',
        ar: 'للطلبات التي تزيد عن $30,000',
        vi: 'Cho đơn hàng trên $30,000',
        th: 'สำหรับคำสั่งซื้อมากกว่า $30,000',
        nl: 'Bij bestellingen boven $30,000',
      })
    }
  ];
}
